import React, {useEffect} from 'react';
import {
    MembershipPageBackgroud,
    UserDataConfigurationBox,
} from './style';
import {useDispatch} from "react-redux";
import {hideNavBar, showNavBar} from "../../_store/_actions/uiActions";
import PersonalStep from "./PersonalStep";
import MembershipStep from "./MembershipStep";
import SaveOnResortStep from "./SaveOnResortStep";
import StepWizard from 'react-step-wizard';

function MembershipPage(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(hideNavBar());

        return () => {
            dispatch(showNavBar());
        };
    }, []);

    return (
        <MembershipPageBackgroud>
            <UserDataConfigurationBox>

                <div className="card nomargin nopadding">
                    <h5 className="card-header">Membership Information</h5>
                    <StepWizard className="card-body">
                        <PersonalStep/>
                        <MembershipStep/>
                        <SaveOnResortStep/>
                    </StepWizard>
                </div>

            </UserDataConfigurationBox>
        </MembershipPageBackgroud>
    );
}

export default MembershipPage;